// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewStatusBar_container__1bnKc"};